export default function room(state = {
  allRooms: [],
  room: {}
}, action) {
  switch (action.type) {
    case "ROOM_CREATED":
      return state
    case "ROOMS_FETCHED":
      return Object.assign({}, state, {
        allRooms: action.payload.rooms,
        room: {}
      })
    case "EVENT_FETCHED":
      return Object.assign({}, state, {
        allRooms: action.payload.rooms
      })
    case "ROOM_FETCHED":
      return Object.assign({}, state, {
        room: action.payload.room
      })
    default:
      return state
  }
}
